import * as actionTypes from "../constants/categoryConstants";
import * as api from "../../api/index";
import { store } from "../../api/index";

export const getCategories = () => async (dispatch) => {
  try {
    const { data } = await api.getCategories(store);
    dispatch({ type: actionTypes.GET_CATEGORIES, payload: data });
  } catch (error) {
    console.log("error", error);
  }
};
